import { Button as AntdButton, Tooltip } from "antd";

export default function Button({
	className,
	textstyle,
	onClick,
	type,
	disabled,
	loading,
	img,
	text,
	img2,
	htmlType,
	children,
	danger,
	icon,
	tooltip,
	imgspacing,
	style,
}) {
	const buttonContent = (
		<>
			<AntdButton
				className={`${className} ${
					type === "default" || type === "" ? "outline-button" : "green-btn"
				}`}
				onClick={onClick}
				type={type}
				disabled={disabled ?? false}
				loading={loading ?? false}
				htmlType={htmlType ?? "button"}
				danger={danger ?? false}
				icon={icon ? icon : undefined}
				style={style}
			>
				{children ? children : null}
				{img && (
					<img
						className={imgspacing === false ? "" : "me-2"}
						src={`${process.env.PUBLIC_URL}/assets/${img}`}
						alt=""
					/>
				)}
				{text && <div className={textstyle}>{text}</div>}
				{img2 && (
					<img src={`${process.env.PUBLIC_URL}/assets/${img2}`} alt="" />
				)}
			</AntdButton>
		</>
	);
	return tooltip ? (
		<Tooltip title={tooltip}>{buttonContent}</Tooltip>
	) : (
		buttonContent
	);
}
